import DebugMenu from '@/debug/DebugMenu';

import useSoftReload from '@/lostHooks/softReload/useSoftReload';
import { isNonProduction } from '@/utilities/logger/datadog/vitals/vitalsStorage';

const DebugWrapper = ({ children }) => {
  const { reload } = useSoftReload();

  if (!isNonProduction()) return children;

  return (
    <>
      <DebugMenu
        tryAgain={() => reload({ preset: 'iframe-only' })}
        tryAgainWithLogout={() =>
          reload({ preset: 'logout', forceIframeReload: true })
        }
      />
      {children}
    </>
  );
};

export default DebugWrapper;
